import { c as _c } from "react/compiler-runtime";
import { DateFull, type DateProps } from '@/app/components/card/shared/meta/date-full';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { stripPTags } from '@/app/utils/format';
export interface CardSharedContentProps {
  title: string;
  description?: string;
  date?: DateProps | null;
  titleClassName?: string;
  titleLineClamp?: boolean;
  descriptionClassName?: string;
  descriptionLineClamp?: boolean;
  dateClassName?: string;
  untilText?: string | boolean;
}
export const CardSharedContent = t0 => {
  const $ = _c(21);
  const {
    title,
    description: t1,
    date: t2,
    titleClassName,
    titleLineClamp: t3,
    descriptionClassName,
    descriptionLineClamp: t4,
    dateClassName,
    untilText: t5
  } = t0;
  const description = t1 === undefined ? "" : t1;
  const date = t2 === undefined ? null : t2;
  const titleLineClamp = t3 === undefined ? true : t3;
  const descriptionLineClamp = t4 === undefined ? true : t4;
  const untilText = t5 === undefined ? false : t5;
  const t6 = !!titleLineClamp;
  let t7;
  if ($[0] !== t6 || $[1] !== titleClassName) {
    t7 = cn("text-sub-h3 font-noto-bold", {
      "line-clamp-2 h-12 xl:h-auto xl:min-h-12": t6
    }, titleClassName);
    $[0] = t6;
    $[1] = titleClassName;
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  let t8;
  if ($[3] !== title) {
    t8 = {
      __html: title
    };
    $[3] = title;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = createDataAttributes({
      test: "title"
    });
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  let t10;
  if ($[6] !== t7 || $[7] !== t8) {
    t10 = <h3 className={t7} dangerouslySetInnerHTML={t8} {...t9} />;
    $[6] = t7;
    $[7] = t8;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] !== description || $[10] !== descriptionClassName || $[11] !== descriptionLineClamp) {
    t11 = !!description && <div className={cn("mt-1", {
      "line-clamp-2": !!descriptionLineClamp
    }, descriptionClassName)} dangerouslySetInnerHTML={{
      __html: stripPTags(description)
    }} {...createDataAttributes({
      test: "description"
    })} />;
    $[9] = description;
    $[10] = descriptionClassName;
    $[11] = descriptionLineClamp;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== date || $[14] !== dateClassName || $[15] !== untilText) {
    t12 = !!date && <DateFull date={date} untilText={untilText} className={dateClassName} />;
    $[13] = date;
    $[14] = dateClassName;
    $[15] = untilText;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t10 || $[18] !== t11 || $[19] !== t12) {
    t13 = <>{t10}{t11}{t12}</>;
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  return t13;
};